import React from 'react';
import { Box, Typography } from '@mui/material';
import { LegalAnnoucement } from '../../../types';

type LegalAnnouncementCaptionInfosProps = {
    articleLabel: string;
    legalAnnouncement?: LegalAnnoucement;
};

const LegalAnnouncementCaptionInfos: React.FunctionComponent<LegalAnnouncementCaptionInfosProps> =
    function ({ articleLabel, legalAnnouncement }) {
        return (
            <Box>
                <Typography>{articleLabel}</Typography>
                {legalAnnouncement && (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                        {legalAnnouncement.numero && (
                            <Typography variant="caption">{legalAnnouncement.numero} - </Typography>
                        )}
                        {legalAnnouncement.date && (
                            <Typography variant="caption">
                                Publié le {legalAnnouncement.date}
                            </Typography>
                        )}

                        {legalAnnouncement.numero && (
                            <Typography variant="caption">
                                dans {legalAnnouncement.journal}
                            </Typography>
                        )}

                        {legalAnnouncement.annonceur && (
                            <Typography variant="caption">{legalAnnouncement.annonceur}</Typography>
                        )}
                    </Box>
                )}
            </Box>
        );
    };

export default LegalAnnouncementCaptionInfos;
